import React, { useCallback, useEffect } from 'react';
import { focusFirstElement, updateElementFocus } from '../../../misc/helpers';
import GeneralButton from './GeneralButton';
import './Start.css';

const Start = (obj: any) => {
	
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13){ //32 - spacebar, 36 - enter
			obj.parameters.onClose();
		}
	};

	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('.tutorial-welcome');
			if (!focusableParent) return;
			let focusable = Array.prototype.slice.call(focusableParent.querySelectorAll('.ui-inner-container p'))
			.concat(Array.prototype.slice.call(focusableParent.querySelectorAll('.general-btn-background')))
			.concat(Array.prototype.slice.call(focusableParent.querySelectorAll('.close-bttn')));
			updateElementFocus(e, focusable);
		}
	}, []);

	useEffect(() => {
		console.log('binded event')
		window.document.addEventListener('keydown', handleKey);
		focusFirstElement(handleKey);
	}, [obj]);

	return (
		<div className="ui-container start-container modal-disable-select tutorial-welcome">
			<div className="modal-background">
				<div className="modal-background-shadow">
				</div>
			</div>
			<div className="ui-inner-container" style={{
				width: '100%',
				height: '100%'
			}}>
				<div
					style={{
						width: '773px',
						margin: '0 auto',
						position: 'relative',
						top: '50%',
						userSelect: 'none',
						transform: 'translate(0, -50%)'
					}}>
					<img src="./assets/startscreen/bg.png" style={{
						pointerEvents: 'none',
						userSelect: 'none',
					}}/>
					<div
						className="close-bttn"
						onClick={obj.parameters.onClose}
						onKeyDown={onChangeValueKeyboard}
						tabIndex={0}
						role="button">
						<img 
							
							src="./assets/startscreen/close.png" 
							alt="close" 
							style={{
								position: 'absolute',
								left: '25px',
								top: '25px',
								width: '43px',
								userSelect: 'none',
								cursor: 'pointer'
							}} 
						/>
					</div>
					<p tabIndex={0}
						style={{
							fontSize: '30px',
							fontWeight: 'bold',
							margin: '0',
							position: 'absolute',
							top: '26px',
							width: '94%',
							right: '0',
							pointerEvents: 'none',
							color: 'white'
						}}
					>TUTORIAL - LEARNING OBJECTIVES</p>
					<p style={{
						fontSize: '20px',
						margin: '0px',
						position: 'absolute',
						top: '80px',
						width: '100%',
						paddingLeft: '27px',
						paddingRight: '27px',
						right: '0px',
						pointerEvents: 'none',
						textAlign: 'left',
						color: 'white'
					}}>
						

						<p tabIndex={0}>Welcome to the tutorial for the First Care Responder Bleeding Control Application.</p>
						<p tabIndex={0}>Keep in mind, that this tutorial is meant to help you understand how the simulation works
							before you start any scenarios. Below are the main points that you will learn during this tutorial.<br/>
						<ul>
							<li>How to interact with questions.</li>
							<li>How to interact with the cameras.</li>
							<li>How to interact and apply a pressure dressing.</li>
							<li>How to interact with and tighten a tourniquet.</li>
							<li>Understand how the bleedout timer works.</li>
						</ul>
						</p>
						<p tabIndex={0}>To return to the main menu, tap the "X" button on the top left corner of this window, or,
							tap on the button on the bottom right corner of the simulation.
						<br/><br/> Tap on the Start Scenario button below to start the tutorial.</p>
					</p>
					<GeneralButton key="Start Scenario" text="Start Scenario" onClick={obj.parameters.onDone} style={{
						position: 'absolute',
						bottom: '50px',
						width: '220px',
						/* margin: 0 auto; */
						left: '50%',
						transform: 'translate(-50%, 0)'
					}} />
				</div>
				{/* <p>Click Start to begin</p>
				<button onClick={obj.parameters.onDone}>Start</button> */}
			</div>
			
		</div>
	);
};

export default Start;
